import { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJAIPhotoEditorConfig from '../../../../config/appConfig/FJAIPhotoEditorConfig.js';
import classNames from 'classnames';
import FJImage from '../../../../common/components/FJImage/FJImage.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent.jsx';
import FJVersionConfig from '../../../../config/FJVersionConfig.js';

import styles from './FJEffectPresetPreviewItem.module.less';

function FJEffectPresetPreviewItem({ item, onSelect }) {
    const videoRef = useRef(null);

    const [isPlayingVideo, setIsPlayingVideo] = useState(false);

    const _onMouseOver = () => {
        setIsPlayingVideo(true);
    };

    const _onMouseLeave = () => {
        setIsPlayingVideo(false);
    };

    const handleClick = () => {
        onSelect?.(item);
    };

    // 构造item对象
    const itemData = useMemo(
        () => ({
            ...item,
            imageUrl: `${FJAIPhotoEditorConfig.presetCoverUrl}${item.id}.png?v=${FJVersionConfig.staticPathVersion}`,
            videoUrl: `${FJAIPhotoEditorConfig.presetVideoUrl}${item.id}.mp4?v=${FJVersionConfig.staticPathVersion}`,
        }),
        [item],
    );

    return (
        <div
            className={styles.model_item_wrapper}
            onMouseEnter={_onMouseOver}
            onMouseLeave={_onMouseLeave}
            data-model={itemData.id}
        >
            <FJHoverBoardGradation borderRadius={8} isShowInBorder={true} className={styles.hover_board}>
                <div className={styles.preset_item_box} onClick={handleClick}>
                    <FJImage
                        imgSrc={itemData.imageUrl}
                        boxClassName={classNames(styles.img_box, !itemData.videoUrl ? styles.noVideo : '')}
                        imgClassName={styles.big_img}
                        alt={itemData.templateName}
                    />

                    {isPlayingVideo && itemData.videoUrl && (
                        <video src={itemData.videoUrl} ref={videoRef} loop autoPlay muted disablePictureInPicture />
                    )}
                </div>
            </FJHoverBoardGradation>

            <FJTextWithEllipsisParent className={styles.name} text={FJLocalStore._(itemData.templateName)} />
        </div>
    );
}

FJEffectPresetPreviewItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        templateName: PropTypes.string.isRequired,
    }).isRequired,
    onSelect: PropTypes.func,
};

export default FJEffectPresetPreviewItem;
